import { ApiProxy, IApiProxy } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

import { useContextApp } from "@/screens/app/context/app";

const KEY = "proxy.account_container";

export const useProxyAccountContainerList = (options?: {
  req?: Parameters<typeof ApiProxy.AccountContainer.list>[0];
  useQueryOptions?: Omit<
    UseQueryOptions<Await<IApiProxy.obj["account_container"][] | undefined>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const {
    state: { organizationId },
  } = useContextApp();

  const { data, error, isLoading, isFetching, refetch } = useQuery(
    [
      KEY,
      {
        ...options?.req,
        organizationId,
      },
    ],
    () => ApiProxy.AccountContainer.list(options?.req),
    options?.useQueryOptions,
  );

  return {
    accountContainerList: data,
    accountContainerListError: error,
    isAccountContainerListLoading: isLoading,
    isAccountContainerListFetching: isFetching,
    refetchAccountContainerList: refetch,
  };
};

useProxyAccountContainerList.KEY = KEY;

export const useProxyAccountContainer = (options: {
  req: Parameters<typeof ApiProxy.AccountContainer.retrieve>[0];
  useQueryOptions?: Omit<
    UseQueryOptions<Await<IApiProxy.obj["account_container"]>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const { data, error, isLoading, isFetching, remove } = useQuery(
    [KEY, options?.req],
    async () => {
      const accountContainer = await ApiProxy.AccountContainer.retrieve(
        options.req,
      );
      return accountContainer;
    },
    options?.useQueryOptions,
  );

  return {
    accountContainer: data,
    accountContainerError: error,
    accountContainerRemove: remove,
    isAccountContainerLoading: isLoading,
    isAccountContainerFetching: isFetching,
  };
};

useProxyAccountContainer.KEY = KEY;
